import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Transportation = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Transportation | DMBD 2025" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h3>Beijing Daxing International Airport</h3>
            <br />
            <p>
              <img
                src="./images/beijing/airport1.png"
                width={650}
              // height={300}
              />

            </p>

            <p>
Beijing Daxing International Airport (PKX), also known as Beijing New Airport, is the airport featuring the second largest single-building terminal in the world. It opened its doors on September 26, 2019, and is a multi-awarded airport. It is also the second international airport in Beijing. Indeed, Beijing Daxing Airport and Beijing Capital International Airport are the two international aviation hubs of the Chinese capital, as the adjacent Beijing Nanyuan Airport closed once the new airport began its operation.
<br></br>
            <br></br>

              <p>
                <img
                  src="./images/beijing/airport2.png"
                  width={650}
                // height={300}
                />
              </p>
              <br></br>

            </p>
The airport’s design is pioneering. Designed by the renowned architect Zaha Hadid, the terminal is spread over 700,000m² (7,500,000 sq ft) and is considered a state of art. Moreover, PKX Airport boasts 4 runways (as well as one military runway) and an impressive number of 82 boarding gates. On the other hand, its location in Daxing District (the southern suburbs of Beijing) is ideal for serving the Chinese capital and the neighboring areas of Hebei and Tianjin. The new mega-airport hub served more than 39.4 million passengers in 2023 and is expected to reach an outstanding 100 million passenger flow in the future.             <br></br>

            <p>
              For more information, please visit{" "}
              <a href="https://daxing-pkx-airport.com/">https://daxing-pkx-airport.com/</a>
            </p>
            
            <h3>Beijing Capital International Airport</h3>
            <br />
            <p>
              <img
                src="./images/beijing/airport3.jpg"
                width={650}
              // height={300}
              />

            </p>

            <p>
Beijing Capital International Airport (IATA: PEK, ICAO: ZBAA) is the main international airport serving the city of Beijing in People’s Republic of China. It is the world’s busiest airport and the largest Chinese airport.
            <br></br>

              <p>
                <img
                  src="./images/beijing/airport4.png"
                  width={650}
                // height={300}
                />
              </p>
              <br></br>

            </p>
Beijing Capital Airport is located 32 km (20 miles) northeast of city center, at Chaoyang-Sunyi District.
            <p>
              For more information, please visit{" "}
              <a href="https://en.bcia.com.cn/">https://en.bcia.com.cn/</a>
            </p>

            <hr></hr>
            <h3>Beijing Railway Station</h3>
            <br />
            <img
              src="./images/beijing/rw1.jpg"
              width={650}
            /> 
            <p>
Beijing Railway Station is one of the oldest and most important railway stations in Beijing. Located in the Dongcheng District, it serves as a major hub for trains heading to northeastern and eastern China. The station features a distinctive Soviet-style architecture, reflecting its historical significance and cultural heritage.                <p>
                <img
                  src="./images/beijing/rww1.png"
                  width={650}
                />
              </p>
            <br></br>
Today, Beijing Railway Station handles a mix of conventional and high-speed trains, connecting Beijing to cities like Shanghai, Harbin, and Tianjin. It is conveniently accessible via Beijing Subway Line 2, making it a key transportation hub for both locals and tourists.            </p>
            
            <hr></hr>
            <h3>Beijing North Railway Station</h3>
            <br />
            <img
              src="./images/beijing/rw2.jpg"
              width={650}
            /> 
            <p>
Beijing North Railway Station is a smaller but strategically located station in the Xicheng District. It primarily serves trains to northern destinations, including the popular high-speed train to Badaling Great Wall and the suburban S2 line. The station underwent a major renovation in recent years to modernize its facilities.                <p>
                <img
                  src="./images/beijing/rww2.png"
                  width={650}
                />
              </p>
            <br></br>
Known for its proximity to the Beijing Zoo and the National Library, Beijing North Railway Station is a convenient starting point for travelers exploring the city’s cultural attractions. It is also connected to Beijing Subway Lines 2, 4, and 13, providing easy access to other parts of the city.            </p>
            
            <hr></hr>
            <h3>Beijing South Railway Station</h3>
            <br />
            <img
              src="./images/beijing/rw3.jpg"
              width={650}
            /> 
            <p>
Beijing South Railway Station is one of the largest and most modern railway stations in China. Located in the Fengtai District, it serves as the primary hub for high-speed trains, including the Beijing-Shanghai High-Speed Railway and the Beijing-Tianjin Intercity Railway.                <p>
                <img
                  src="./images/beijing/rww3.png"
                  width={650}
                />
              </p>
            <br></br>
The station’s futuristic design and state-of-the-art facilities make it a standout landmark in Beijing. It is well-integrated with the city’s public transportation network, including Beijing Subway Lines 4 and 14, offering seamless connectivity for travelers. Beijing South Railway Station is a gateway to major cities across China, making it a vital part of the country’s high-speed rail network.            </p>

            {/* <hr></hr> */}
{/* 
            <h3>Nanning East Railway Station</h3>
            <br />
            <img
              src="./images/nanning/nanninge.png"
              width={650}
            />
            <br></br>
            <p>
            Nanning East Railway Station, inaugurated in 2014, is a modern transportation hub situated in the eastern part of Nanning city, the capital of Guangxi Zhuang Autonomous Region, China. 
            This station is a part of the country&apos;s extensive high-speed rail network and primarily serves high-speed trains, including services on the Nanning-Guangzhou line. 
                <p>
                <img
                  src="./images/nanning/nanninge2.png"
                  width={650}
                />
              </p>
              <br></br>
            With its sleek and contemporary design, the station provides passengers with state-of-the-art facilities and a seamless travel experience. 
            It has become a critical link for regional connectivity, contributing to the economic development of Guangxi and enhancing the accessibility to and from other major cities in China and neighboring countries.
            
            </p> */}



            {/* <p>
              From Qingdao Railway Station -&gt; Subway line 3 -&gt; May Fourth
              Square Station -&gt; Subway line 2 -&gt; Miaoling Road Station
              -&gt; Qingdao Blue Horizon Hotel Laoshan
            </p>

            <p>&nbsp;</p>
            <h3>To Ocean University Station</h3>
            <p>
              <img
                src="http://39.98.207.139:8080/icsi2021/wp-content/uploads/transport.jpg"
                width={400}
              />
            </p>
            <p>
              From Qingdao International Airport -&gt; 701 Busline Qingdao
              International Airport Station -&gt; Qingdao Car East Station -&gt;
              Subway line 2, Liaoyang East Road Station -&gt; Miaoling Road
              Station -&gt; Subway line 11 , Miaoling Road Station -&gt; Ocean
              University Station
            </p>
            <p>
              Travel time from the airport to Ocean University of China is one
              and a half hours. Airport Line 1 (bus 701) runs every hour from
              the airport to the East Bus Station and tickets can be purchased
              at the ticket counter in the bus for 20RMB in cash or by using the
              Qindao Pass card on the bus, then transfer to Metro Line 2 and
              change to Metro Line 11 in the station to reach Ocean University
              Station and tickets can be purchased at the ticket machine in the
              Metro station for 4RMB.
            </p> */}
          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Transportation | DMBD 2025" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h3>To be released.</h3>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Transportation;
